window.addEventListener("load", (event) => {


const swiper = new Swiper('.referenceSwiper', {
    slidesPerView: 1,
    spaceBetween: 20,
    pagination: {
        el: '.swiper-pagination',
        clickable: true,
    },
    navigation: {
        nextEl: '.pf-next-arrow',
        prevEl: '.pf-prev-arrow',
    },
    loop:true,
    breakpoints: {
        // when window width is >= 768px
        768: {
            slidesPerView: 2,
        },
        // when window width is >= 992px
        992: {
            slidesPerView: 3,
        }
    }
});



// about-page
 // Add smooth scrolling for anchor links
 document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function (e) {
        e.preventDefault();
        document.querySelector(this.getAttribute('href')).scrollIntoView({
            behavior: 'smooth'
        });
    });
});

// Add navbar background on scroll
window.addEventListener('scroll', function() {
    const navbar = document.querySelector('.pf-navbar');
    if (window.scrollY > 50) {
        navbar?.classList.add('pf-navbar-shadow');
    } else {
        navbar?.classList.remove('pf-navbar-shadow');
    }
});

});